<template>
  <section class="">
    <section slot="pdf-content" class="report_page">
      <div class="water_mark"></div>
      <header>
        <div class="logo">
          <img width="200px" src="@/assets/images/icons/foot_logo.png" alt="" />
        </div>
        <button @click="downloadPdf()" type="button" class="np-btn">
          jjjjjjj
        </button>
      </header>
      <div class="report_tables">
        <h2 class="title">تقرير عام</h2>
        <div class="top_table">
          <div class="top_table_content">
            <table>
              <th colspan="2">معلومات عن التقارير</th>
              <tr>
                <td>هدف التقرير</td>
                <td>احصائية لوحه التحكم</td>
              </tr>
              <tr>
                <td>هدف التقرير</td>
                <td>احصائية لوحه التحكم</td>
              </tr>
              <tr>
                <td>هدف التقرير</td>
                <td>احصائية لوحه التحكم</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="report_table">
          <div class="top_table_content">
            <div class="table-responsive">
              <table class="">
                <thead>
                  <th>التاريخ</th>
                  <th>العملاء</th>
                  <th>السائقين</th>
                  <th>الرحلات الملغية</th>
                  <th>الرحلات المنتهيه</th>
                  <th>رحلات منتهيه من السيستم بعد 100 دقيقه</th>
                  <th>اسباب الغاء العميل</th>
                  <th>اسباب الغاء السائق</th>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ new Date().toLocaleDateString() }}</td>
                    <td>20 عميل</td>
                    <td>20 سائق</td>
                    <td>20</td>
                    <td>20</td>
                    <td>20</td>
                    <td>20</td>
                    <td>20</td>
                  </tr>
                  <tr>
                    <td>{{ new Date().toLocaleDateString() }}</td>
                    <td>20 عميل</td>
                    <td>20 سائق</td>
                    <td>20</td>
                    <td>20</td>
                    <td>20</td>
                    <td>20</td>
                    <td>20</td>
                  </tr>
                  <tr>
                    <td>{{ new Date().toLocaleDateString() }}</td>
                    <td>20 عميل</td>
                    <td>20 سائق</td>
                    <td>20</td>
                    <td>20</td>
                    <td>20</td>
                    <td>20</td>
                    <td>20</td>
                  </tr>
                </tbody>
                <tfoot>
                  <td>اجمالي الاسبوع</td>
                  <td>20 عميل</td>
                  <td>20 سائق</td>
                  <td>20 رحلة</td>
                  <td>20 رحلة</td>
                  <td>20 رحلة</td>
                  <td>20</td>
                  <td>20</td>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <div class="content">
          <div class="contacts_info">
            <p><i class="fas fa-location-dot"></i> <span>cairo</span></p>
            <p><i class="fas fa-location-dot"></i> <span>cairo</span></p>
            <p><i class="fas fa-phone"></i> <span>01001010101000</span></p>
            <p><i class="fas fa-phone"></i> <span>01001010101000</span></p>
            <p><i class="fas fa-envelope"></i> <span>test@test.com</span></p>
            <p><i class="fas fa-globe"></i> <span>www.google.com</span></p>
          </div>
        </div>
      </footer>
    </section>
    <vue-html2pdf
      :show-layout="controlValue.showLayout"
      :float-layout="controlValue.floatLayout"
      :enable-download="controlValue.enableDownload"
      :preview-modal="controlValue.previewModal"
      :filename="controlValue.filename"
      :paginate-elements-by-height="controlValue.paginateElementsByHeight"
      :pdf-quality="controlValue.pdfQuality"
      :pdf-format="controlValue.pdfFormat"
      :pdf-orientation="controlValue.pdfOrientation"
      :pdf-content-width="controlValue.pdfContentWidth"
      :manual-pagination="controlValue.manualPagination"
      :html-to-pdf-options="htmlToPdfOptions"
      @progress="onProgress($event)"
      @startPagination="startPagination()"
      @hasPaginated="hasPaginated()"
      @beforeDownload="beforeDownload($event)"
      @hasDownloaded="hasDownloaded($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div
          class="report_page px-4"
          style="display: flex; flex-direction: column"
        >
          <div class="water_mark"></div>
          <header>
            <div class="logo">
              <img
                width="200px"
                src="@/assets/images/icons/foot_logo.png"
                alt=""
              />
            </div>
          </header>
          <div class="report_tables">
            <h2 class="title">تقرير عام</h2>
            <div class="top_table">
              <div class="top_table_content">
                <table>
                  <th colspan="2">معلومات عن التقارير</th>
                  <tr>
                    <td>هدف التقرير</td>
                    <td>احصائية لوحه التحكم</td>
                  </tr>
                  <tr>
                    <td>هدف التقرير</td>
                    <td>احصائية لوحه التحكم</td>
                  </tr>
                  <tr>
                    <td>هدف التقرير</td>
                    <td>احصائية لوحه التحكم</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="report_table">
              <div class="top_table_content">
                <div class="table-responsive">
                  <table class="">
                    <thead>
                      <th>التاريخ</th>
                      <th>العملاء</th>
                      <th>السائقين</th>
                      <th>الرحلات الملغية</th>
                      <th>الرحلات المنتهيه</th>
                      <th>رحلات منتهيه من السيستم بعد 100 دقيقه</th>
                      <th>اسباب الغاء العميل</th>
                      <th>اسباب الغاء السائق</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ new Date().toLocaleDateString() }}</td>
                        <td>20 عميل</td>
                        <td>20 سائق</td>
                        <td>20</td>
                        <td>20</td>
                        <td>20</td>
                        <td>20</td>
                        <td>20</td>
                      </tr>
                      <tr>
                        <td>{{ new Date().toLocaleDateString() }}</td>
                        <td>20 عميل</td>
                        <td>20 سائق</td>
                        <td>20</td>
                        <td>20</td>
                        <td>20</td>
                        <td>20</td>
                        <td>20</td>
                      </tr>
                      <tr>
                        <td>{{ new Date().toLocaleDateString() }}</td>
                        <td>20 عميل</td>
                        <td>20 سائق</td>
                        <td>20</td>
                        <td>20</td>
                        <td>20</td>
                        <td>20</td>
                        <td>20</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <td>اجمالي الاسبوع</td>
                      <td>20 عميل</td>
                      <td>20 سائق</td>
                      <td>20 رحلة</td>
                      <td>20 رحلة</td>
                      <td>20 رحلة</td>
                      <td>20</td>
                      <td>20</td>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <footer style="margin-top: auto">
            <div class="content">
              <div class="contacts_info">
                <p><i class="fas fa-location-dot"></i> <span>cairo</span></p>
                <p><i class="fas fa-location-dot"></i> <span>cairo</span></p>
                <p><i class="fas fa-phone"></i> <span>01001010101000</span></p>
                <p><i class="fas fa-phone"></i> <span>01001010101000</span></p>
                <p>
                  <i class="fas fa-envelope"></i> <span>test@test.com</span>
                </p>
                <p><i class="fas fa-globe"></i> <span>www.google.com</span></p>
              </div>
            </div>
          </footer>
        </div>
        <div class="html2pdf__page-break" />
      </section>
    </vue-html2pdf>
  </section>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
export default {
  components: { VueHtml2pdf },
  data() {
    return {
      contentRendered: false,
      progress: 0,
      generatingPdf: false,
      pdfDownloaded: false,
      controlValue: {
        showLayout: false,
        floatLayout: true,
        enableDownload: false,
        previewModal: true,
        paginateElementsByHeight: 2999,
        manualPagination: true,
        filename: "Captin1 Report",
        pdfQuality: 2,
        pdfFormat: "a4",
        pdfOrientation: "portrait",
        pdfContentWidth: "800px",
      },
    };
  },
  computed: {
    htmlToPdfOptions() {
      return {
        margin: 0,
        filename: "hee hee.pdf",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        enableLinks: true,
        html2canvas: {
          scale: this.controlValue.pdfQuality,
          useCORS: true,
        },
        jsPDF: {
          unit: "in",
          format: this.controlValue.pdfFormat,
          orientation: this.controlValue.pdfOrientation,
        },
      };
    },
  },
  methods: {
    async downloadPdf() {
      if (!(await this.validateControlValue())) return;
      this.$refs.html2Pdf.generatePdf();
    },
    validateControlValue() {
      if (this.controlValue.pdfQuality > 2) {
        alert("pdf-quality value should only be 0 - 2");
        this.controlValue.pdfQuality = 2;
        return false;
      }
      if (!this.controlValue.paginateElementsByHeight) {
        alert("paginate-elements-by-height value cannot be empty");
        this.controlValue.paginateElementsByHeight = 11.7;
        return false;
      }
      const paperSizes = [
        "a0",
        "a1",
        "a2",
        "a3",
        "a4",
        "letter",
        "legal",
        "a5",
        "a6",
        "a7",
        "a8",
        "a9",
        "a10",
      ];
      if (!paperSizes.includes(this.controlValue.pdfFormat)) {
        alert(`pdf-format value should only be ${paperSizes}`);
        this.controlValue.pdfFormat = "a4";
        return false;
      }
      if (!this.controlValue.pdfOrientation) {
        alert("pdf-orientation value cannot be empty");
        this.controlValue.pdfOrientation = "portrait";
        return false;
      }
      if (!this.controlValue.pdfContentWidth) {
        alert("pdf-content-width value cannot be empty");
        this.controlValue.pdfContentWidth = "800px";
        return false;
      }
      return true;
    },
    onProgress(progress) {
      this.progress = progress;
      console.log(`PDF generation progress: ${progress}%`);
    },
    startPagination() {
      console.log(`PDF has started pagination`);
    },
    hasPaginated() {
      console.log(`PDF has been paginated`);
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      console.log(`On Before PDF Generation`);
      // await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
      // 	const totalPages = pdf.internal.getNumberOfPages()
      // 	for (let i = 1; i <= totalPages; i++) {
      // 		pdf.setPage(i)
      // 		pdf.setFontSize(10)
      // 		pdf.setTextColor(150)
      // 		pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
      // 	}
      // }).save()
    },
    async toDataUrLImage(res) {
      return await this.toDataUrl(res);
    },
    hasDownloaded(blobPdf) {
      console.log(`PDF has downloaded yehey`);
      this.pdfDownloaded = true;
      console.log(blobPdf);
    },
    domRendered() {
      console.log("Dom Has Rendered");
      this.contentRendered = true;
    },
    onBlobGenerate(blob) {
      console.log(blob);
      console.log(blob);
    },
  },
};
</script>

<style lang="scss">
.report_page {
  position: relative;
  z-index: 2;
  display: flex;
  height: 11.6in;
  flex-direction: column;
  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid var(--mainColor-4);
    .logo {
      text-align: start;
      img {
        padding: 10px;
        border-bottom: 2px solid var(--main);
      }
    }
  }
  .report_tables {
    h2.title {
      text-align: center;
      font-size: 25px !important;
      font-weight: 600;
      margin-block: 30px;
    }
    .top_table {
      margin-top: 1.5rem;
      .top_table_content {
        table {
          width: 80%;
          margin-inline: auto;
          th {
            background: var(--main);
            padding: 10px 0;
            color: #fff;
            text-align: center;
          }
        }
      }
    }
  }
  .report_table {
    margin-top: 1.5rem;
    table {
      width: 100%;
      thead {
        background: var(--mainColor-4);
        th {
          font-size: 15px;
          padding: 5px 8px;
        }
      }
      tbody {
        td {
          &:not(:first-child) {
            font-size: 13px;
          }
        }
      }
      tfoot {
        td {
          text-align: center;
          padding: 5px;
          font-size: 15px;
          font-weight: 600;
          &:first-child {
            font-size: 16px;
            white-space: nowrap;
          }
        }
      }
    }
  }
  footer {
    margin-top: auto;
    padding-block: 10px;
    border-top: 3px solid var(--secodary-color);
    .content {
      position: relative;
      .contacts_info {
        padding-inline-start: 20px;
        display: block;
        column-count: 3;
        p {
          margin-bottom: 5px;
          font-size: 16px;
          font-weight: 600;
          i {
            color: var(--secodary-color);
            margin-inline-end: 5px;
            font-size: 18px;
          }
        }
      }
      &::before {
        content: "";
        height: 100%;
        width: 10px;
        background: var(--secodary-color);
        position: absolute;
        border-top-left-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }
  }
  table,
  th,
  td {
    border: 1px solid var(--main);
  }
  table {
    margin-inline: auto;
    th {
      padding: 10px 0;
      text-align: center;
    }
    tr {
      td:first-child {
        white-space: nowrap;
        font-weight: 600;
        font-size: 16px;
      }
      td {
        text-align: center;
        padding: 5px 8px;
        font-size: 14px;
        font-weight: 600;
        min-width: 80px;
      }
    }
  }
  .water_mark {
    position: absolute;
    background: url("~@/assets/images/icons/foot_logo.png");
    background-size: cover;
    background-repeat: no-repeat;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    z-index: -1;
  }
  button {
    background: var(--main);
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
  }
}
</style>
